<template>
  <!-- 新技术学习目标 -->
    <div class="selective-disease">
        <img src="@/assets/images/cartojourney/img01.png" class="img-bg" alt="">
        <div class="top-con">
            <img src="@/assets/images/cartojourney/img08.png" class="con-title" alt="">
        </div>
        <div class="con-list">
            <div class="con-items" v-for="(item, index) in technology" :key="index" @click="handleClickItems(item, index)" :class="item.check ? 'ischecked' : ''">
                <div class="items-checked items-istrue">
                    <img src="@/assets/images/cartojourney/img05.png" v-if="item && item.check" class="icon-check" alt="">
                    <img src="@/assets/images/cartojourney/img06.png" v-else class="icon-check" alt="">
                </div>
                <span class="items-txt">{{ item && item.technologyName }}</span>
            </div>
        </div>
        <div class="submit-btn" @click="handleSubmit">确定</div>
    </div>
</template>
<script>
import { technologyList } from '@/api/grade.js'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data() {
    return {
      technology: [],
      technologyNames: [],
      diseaseNames: '',
    }
  },
  created() {
    if (sessionStorage.getItem('createGrade')) {
      let { diseaseNames, technologyNames } = JSON.parse(sessionStorage.getItem('createGrade'))
      this.diseaseNames = diseaseNames
      this.technologyNames = technologyNames.split(',')
    }
  },
  mounted() {
    technologyList({diseaseNames: this.diseaseNames}).then(res => {
      const data = res.data
      this.technology = data.map(item => {
        if (this.technologyNames.includes(item.technologyName)) {
          item.check = true
        } else {
          item.check = false
        }
        return item
      })
    })
  },
  methods: {
    handleClickItems(item, index) {
      this.technology[index].check = !item.check
    },
    // 组装缓存
    eachStorage(technologyNames) {
      let changeListCon = {}
      let storageCon = {}
      if (sessionStorage.getItem('createGrade')) {
        storageCon = JSON.parse(sessionStorage.getItem('createGrade'))
      } else {
        storageCon = {
          className: '',
          adminsList: [],
          studentsList: []
        }
      }
      changeListCon = Object.assign(storageCon, { technologyNames })
      sessionStorage.setItem('createGrade', JSON.stringify(changeListCon))
    },
    handleSubmit() {
      let list = this.technology.filter((res) => res.check).map(res => res.technologyName)
      if (!list.length) return this.$toast('未选择新技术学习')
      let technologyNames = list.join(',')
      this.eachStorage(technologyNames)
      this.classId = this.$route.query.classId
      if (this.classId) {
        this.$router.push({
          path: '/createGrade',
          query: {
            classId: this.classId,
          },
        })
      } else {
        this.$router.push({
          path: '/createGrade',
        })
      }
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.selective-disease {
    min-height: 100vh;
    background-color: #F0F1F6;
    padding-bottom: 72px;
    box-sizing: border-box;
    .img-bg {
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
    }
    .top-con {
        background-image: url('../../assets/images/cartojourney/img01.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 65px;
        z-index: 9;
        padding-left: 12px;
        padding-top: 27px;
        box-sizing: border-box;
        .con-title {
            width: 125px;
            display: block;
        }
    }
    .con-list {
        position: relative;
        padding: 0 12px;
        box-sizing: border-box;
        padding-top: 65px;
        z-index: 2;
        .con-items {
            background-color: #fff;
            border-radius: 8px;
            display: flex;
            align-items: center;
            height: 48px;
            box-sizing: border-box;
            margin-bottom: 8px;
            position: relative;
            padding: 0 12px;
            &.ischecked {
                border: 1px solid #EB1700;
                box-sizing: border-box;
            }
            .items-checked {
                border-radius: 8px;
                margin-right: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                .icon-check {
                  width: 20px;
                  display: block;
                }
            }
            .items-txt {
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 500;
              font-size: 16px;
              color: #000;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
        }
    }
    .submit-btn {
        background-color: #EB1700;
        position: fixed;
        left: 10px;
        width: calc(100% - 20px);
        height: 42px;
        line-height: 42px;
        text-align: center;
        bottom: 15px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        border-radius: 100px;
        z-index: 9;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/selectiveTechnique.vue